import { IMessageImport } from "@/lib/interfaces and Enums/InterfaceAxes";
import { fetchRequestWrapper } from "@/lib/utilities";
import { addAxeToStore } from "@/store/axeMessageImportStoreACTIONS";
import { User } from "@auth0/auth0-react";

export async function sendAxeImportData(
  incomingMessage: string,
  user: User | undefined,
  getAccessTokenSilently: Function,
  setBorderColor: Function,
  setHelperText: Function,
) {
  if (incomingMessage == "") {
    setBorderColor("error");
    setHelperText("Axe Data required");
    return;
  }

  const objToSend: IMessageImport = {
    messageType: "Axe", //always axe
    subType: "Bond", // (for now) always bond
    source: "Internal", // always internal
    clientDetails: {
      originatingEntity: "string",
      lei: "string",
      traderName: "string",
    },
    axeDetails: {
      originalMessage: incomingMessage,
    },
  };

  const userCustomer = user?.["https://liquiditycube.net/customer"];
  // const userLei = user?.[]

  objToSend.clientDetails = {
    originatingEntity: user ? userCustomer.primary : "string",
    lei: "5549300OHQV7UC61L8Y70", //todo update user ? userLei. : "string"
    traderName: user?.name ? user.name : "string",
  };

  setBorderColor("warning");
  setHelperText("Loading...");

  const generateAxesResponse = await fetchRequestWrapper(
    {
      url: "/Axe/Import",
      method: "POST",
      objToSend: objToSend,
    },
    getAccessTokenSilently,
  );

  addAxeToStore(generateAxesResponse.axes);
  if (generateAxesResponse.axes.length > 0) {
    setBorderColor("success");
    setHelperText("Axe Data Generated");
  } else {
    setBorderColor("error");
    setHelperText(
      "Error Generating Axe Data. Please adjust message and try again",
    );
  }
}

//example message

// {FR}
//  Bid  75MM FRTR 0 3/4 05/25/52 FR0013480613
//  offer 50MM FRTR 1 1/4 05/25/36 FR0013154044
//  offer 75MM FRTR 1 1/4 05/25/38 FR0014009O62
